<template>
  <modal title="Social Platform Disabled" ref="modal">
    <message type="info">
      {{ socialSite.name}} connection is currently disabled. Please try again later.
    </message>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { SocialSite } from '@/type';
import Message from '@/components/message/Message.vue';

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    Message,
    Modal,
  },
  props: {
    socialSite: {
      type: Object as () => SocialSite,
      required: true,
    },
  },
});
</script>
